<section class="tcc-page">
  <div class="tcc-heading">
    <h1>Tax Compliance Certificate</h1>
  </div>

  <article class="request-card">
    <div class="request-card-content">
      <h2>Apply for TCC</h2>
      <p>Request a Tax Compliance Certificate for government transactions, concessions, contract bidding, loan applications, or other official requirements.</p>
    </div>
    <button type="button" class="request-button" (click)="requestCertificate()">
      Request Tax Compliance Certificate
      <mat-icon aria-hidden="true">arrow_forward</mat-icon>
    </button>
  </article>

  <section class="requests-section" aria-labelledby="previous-tcc-heading">
    <div class="requests-header-row">
      <h2 id="previous-tcc-heading">Previously submitted Tax Compliance Certificate requests</h2>
      <div class="search-box">
        <input type="text" class="search" placeholder="Search" [(ngModel)]="searchText"
          (keyup)="searchPrediction($event)" (ngModelChange)="onFilterChange()" />
        <mat-icon class="search-icon" (click)="searchText ? clearText() : search()">
          {{ searchText ? 'close' : 'search' }}
        </mat-icon>
      </div>
    </div>
    <div class="requests-table-wrapper">
      <table class="requests-table">
        <thead>
          <tr>
            <th *ngFor="let heading of tableData.tableHeadings">{{ heading }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of paginatedRows">
            <td *ngFor="let value of row; let columnIndex = index">
              <ng-container [ngSwitch]="tableData.tableHeadings[columnIndex]">
                <span *ngSwitchCase="'Status'" class="status-badge"
                  [ngClass]="getStatusClass(value)">{{ getStatusLabel(value) }}</span>
                <ng-container *ngSwitchCase="'Action'">
                  <div *ngIf="isDraftStatus(row[3]); else standardAction" class="draft-actions">
                    <button type="button" class="action-button" (click)="openRequest(row[0])">Resume</button>
                    <button type="button" class="action-button danger"
                      title="Discard will be available when the discard API is created">Discard</button>
                  </div>
                  <ng-template #standardAction>
                    <button *ngIf="isViewableStatus(row[3]); else existingAction" type="button" class="action-button"
                      (click)="openRequest(row[0], row[3])">View</button>
                    <ng-template #existingAction>
                      <button *ngIf="value !== '-'; else noAction" type="button" class="action-button"
                        (click)="openRequest(row[0], row[3])">{{ value }}</button>
                    </ng-template>
                    <ng-template #noAction>-</ng-template>
                  </ng-template>
                </ng-container>
                <a *ngSwitchCase="'Case ID'" href=""
                  (click)="openRequestAction($event, row[0], value)">{{ value }}</a>
                <span *ngSwitchDefault>{{ value }}</span>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="!tableData.tableData.length">
            <td class="empty-table-state" [attr.colspan]="tableData.tableHeadings.length">
              <mat-icon>search_off</mat-icon>
              <p>No data available for the search term</p>
              <button type="button" class="clear-search-button" (click)="clearText()">Clear Search</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-mat-paginator
      [currentPage]="currentPage"
      [visiblePages]="visiblePages"
      [totalPages]="totalPages"
      [showEllipsis]="false"
      (pageChange)="onPageChange($event)">
    </app-mat-paginator>
  </section>
</section>

